/* src/app/components/case/download-briefcase/edit-briefcase/edit-briefcase.component.scss */
.container {
  margin: 20px auto;
  padding: 0 20px;
  flex: 1 1 0;
  box-sizing: border-box;
  flex-direction: column;
  display: flex;
  place-content: stretch space-between;
  align-items: stretch;
}
.container > mat-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.document-button-text {
  display: flex;
  align-items: center;
}
.document-button-text mat-icon {
  margin-right: 5px;
}
.form-control-wrapper {
  padding-bottom: 10px;
}
.form-control-wrapper mat-form-field {
  width: 50%;
}
/*# sourceMappingURL=edit-briefcase.component.css.map */
